// extracted by mini-css-extract-plugin
export default {"privacy":"PrivacyPolicy_privacy__hu6WZ"};